import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center px-4">
      <form onSubmit={submit} className="rise w-full max-w-sm space-y-4 rounded-3xl border border-white/[0.08] bg-[#1A1A1A] p-8">
        <img src="/images/logo.png" alt="Depósito do Primo" data-testid="login-logo" className="mx-auto h-16 w-auto rounded-lg" />
        <div>
          <h1 className="font-display text-3xl font-extrabold">Painel do Primo</h1>          <p className="text-sm text-slate-400">Acesso restrito a administradores</p>
        </div>
        <Input data-testid="login-email-input" type="email" required placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
        <Input data-testid="login-password-input" type="password" required placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} />
        {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
        <Button data-testid="login-submit-button" disabled={loading} className="w-full rounded-full font-bold">{loading ? "Entrando..." : "Entrar"}</Button>
      </form>
    </div>
  );
}
